<template>
  <div class="upper-stacking-bar">
    <div :id="barIdName" :style="{width: width, height: height}"></div>
  </div>
</template>

<script>
  import {debounce} from "../../utils/util";

  export default {
    name: 'upper-stacking-bar',
    props: {
      barIdName: {
        type: String,
        default () {
          return 'upperStackingBar'
        }
      },
      width: {
        type: String,
        default () {
          return '100%'
        }
      },
      height: {
        type: String,
        default () {
          return '220px'
        }
      },
      titleShow: {
        type: Boolean,
        default () {
          return true
        }
      },
      barTitle: {
        type: String,
        default () {
          return ''
        }
      },
      tooltipShow: {
        type: Boolean,
        default () {
          return true
        }
      },
      colorList: {
        type: Array,
        default () {
          return ['#5B9BD5', '#ED7D31', '#FFC000', '#A5A5A5']
        }
      },
      legendData: {
        type: Array,
        default () {
          return []
        }
      },
      xAxis: {
        type: Object,
        default () {
          return {}
        }
      },
      yAxis: {
        type: Object,
        default () {
          return {}
        }
      },
      series: {
        type: Array,
        default () {
          return []
        }
      }
    },
    data () {
      return {
        upperStackingBar: null
      }
    },
    mounted () {
      this.drawUpperHorizontalBar()
      window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.resizeChart)
    },
    methods: {
      drawUpperHorizontalBar() {
        this.upperStackingBar = this.$echarts.init(document.getElementById(this.barIdName))
        this.upperStackingBar.setOption({
          title: {
            show: this.titleShow,
            text: this.barTitle,
            titleStyle: {
              color: '#333333'
            }
          },
          tooltip : {
            show: this.tooltipShow,
            trigger: 'axis',
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {
            data: this.legendData,
            right: 10,
            itemWidth: 10,
            itemHeight: 5,
            textStyle: {
              color: '#ffffff',
              fontSize: 10,
            }
          },
          grid: {
            left: '3%',
            right: '5%',
            top: '25%',
            bottom: '0',
            containLabel: true
          },
          color: this.colorList,
          xAxis: this.xAxis,
          yAxis: this.yAxis,
          series: this.series
        })
      },
      resizeChart: debounce(function () {
        this.upperStackingBar.resize()
      }, 100)
    },
    watch: {
      series () {
        this.drawUpperHorizontalBar()
      }
    }
  }
</script>

<style scoped>
  .upper-stacking-bar {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/UpperEcharts/upperStackingBar.vue